import Icon from '@/components/ui/AppIcon';

interface TrustSignal {
  icon: string;
  title: string;
  description: string;
}

interface TrustSignalsProps {
  currentLanguage: 'fr' | 'de';
}

const TrustSignals = ({ currentLanguage }: TrustSignalsProps) => {
  const content = {
    fr: {
      title: "Pourquoi nous faire confiance",
      signals: [
        {
          icon: "ShieldCheckIcon",
          title: "Assuré et cautionné",
          description: "Couverture d\'assurance complète pour votre tranquillité d\'esprit"
        },
        {
          icon: "ClockIcon",
          title: "Réponse sous 24h",
          description: "Nous nous engageons à répondre à toutes les demandes dans les 24 heures"
        },
        {
          icon: "StarIcon",
          title: "Satisfaction garantie",
          description: "Garantie de satisfaction à 100% ou nous revenons gratuitement"
        },
        {
          icon: "UserGroupIcon",
          title: "Équipe certifiée",
          description: "Personnel formé et certifié aux normes suisses de qualité"
        },
        {
          icon: "MapPinIcon",
          title: "Service local",
          description: "Basé à Le Locle, nous connaissons votre région"
        },
        {
          icon: "ChatBubbleLeftRightIcon",
          title: "Support multilingue",
          description: "Service en français et allemand pour votre confort"
        }
      ] as TrustSignal[]
    },
    de: {
      title: "Warum uns vertrauen",
      signals: [
        {
          icon: "ShieldCheckIcon",
          title: "Versichert und gebunden",
          description: "Vollständige Versicherungsdeckung für Ihre Sicherheit"
        },
        {
          icon: "ClockIcon",
          title: "Antwort innerhalb von 24 Stunden",
          description: "Wir verpflichten uns, alle Anfragen innerhalb von 24 Stunden zu beantworten"
        },
        {
          icon: "StarIcon",
          title: "Zufriedenheitsgarantie",
          description: "100% Zufriedenheitsgarantie oder wir kommen kostenlos zurück"
        },
        {
          icon: "UserGroupIcon",
          title: "Zertifiziertes Team",
          description: "Nach Schweizer Qualitätsstandards geschultes und zertifiziertes Personal"
        },
        {
          icon: "MapPinIcon",
          title: "Lokaler Service",
          description: "Mit Sitz in Le Locle kennen wir Ihre Region"
        },
        {
          icon: "ChatBubbleLeftRightIcon",
          title: "Mehrsprachiger Support",
          description: "Service auf Französisch und Deutsch für Ihren Komfort"
        }
      ] as TrustSignal[]
    }
  };

  const text = content[currentLanguage];

  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-foreground mb-4">
            {text.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {text.signals.map((signal, index) => (
            <div
              key={index}
              className="bg-card rounded-xl shadow-md hover:shadow-xl transition-all duration-300 p-6 border border-border group"
            >
              <div className="flex items-center justify-center w-14 h-14 bg-primary/10 rounded-xl mb-4 group-hover:bg-primary group-hover:scale-110 transition-all duration-300">
                <Icon
                  name={signal.icon as any}
                  size={28}
                  variant="solid"
                  className="text-primary group-hover:text-white transition-colors duration-300"
                />
              </div>

              <h3 className="text-lg font-heading font-bold text-foreground mb-2">
                {signal.title}
              </h3>

              <p className="text-sm text-muted-foreground">
                {signal.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;